import { computed, defineComponent, reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { Account } from '@/store/account/account.model';
import { AccountGetter } from '@/store/account/account.module';
import { UserResetPasswordSchema } from '@/store/user/user.validator';
import { UserAction } from '@/store/user/user.module';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'UserResetPasswordComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    userId: {
      type: String,
    }
  },
  setup: (props) => {
    const store = useStore();
    const account = computed<Account>(() => store.getters[AccountGetter.ACCOUNT]);
    const isLoading = computed<boolean>(() => store.getters['users/status'] === 'init' || store.getters['users/status'] === 'loading');
    const resetPasswordForm = ref<InstanceType<typeof BaseModalComponent>>();

    // form
    const formData = reactive({
      id: computed(() => props.userId),
      password: 'welcome',
      admin: computed(() => account.value?.userName),
      adminPassword: '',
    });
    const validator = computed(() => UserResetPasswordSchema.validate(formData, { abortEarly: false }));
    const errors = reactive({
      adminPassword: computed(() => validator.value.error?.details.some((detail) => detail.path[0] === 'adminPassword'))
    });
    const isValid = computed(() => !errors.adminPassword);
    const submited = ref(false);

    // show modal
    const show = () => {
      resetPasswordForm.value?.show();
    };

    // hide modal
    const hide = () => {
      resetPasswordForm.value?.hide();
    };

    // clear submit status
    const unsubmit = () => {
      submited.value = false;
    };

    // clear form
    const clearForm = () => {
      new Promise<void>((resolve) => {
        formData.adminPassword = '';
        resolve();
      }).then(() => unsubmit());
    };

    // submit form
    const submitClick = () => {
      submited.value = true;

      if (isValid.value) {
        store.dispatch(UserAction.RESET_PASSWORD, formData)
          .then(() => hide());
      }
    };

    return {
      resetPasswordForm,
      formData,
      errors,
      submited,
      isLoading,
      show,
      hide,
      unsubmit,
      clearForm,
      submitClick
    };
  },
});
